var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7958 13.6722V15.7865C17.7958 16.3702 17.3225 16.8436 16.7386 16.8436H14.6244C14.0405 16.8436 13.5673 16.3702 13.5673 15.7865V15.5222H6.96021V16.8436C6.96021 17.2814 6.60512 17.6365 6.16736 17.6365C5.7296 17.6365 5.37451 17.2814 5.37451 16.8436V15.5222H2.99597C2.55821 15.5222 2.20312 15.1671 2.20312 14.7294C2.20312 14.2916 2.55821 13.9365 2.99597 13.9365H5.37451V7.06519H2.99597C2.55821 7.06519 2.20312 6.7101 2.20312 6.27234C2.20312 5.83458 2.55821 5.47949 2.99597 5.47949H5.37451V4.15808C5.37451 3.72032 5.7296 3.36523 6.16736 3.36523C6.60512 3.36523 6.96021 3.72032 6.96021 4.15808V5.47949H9.33875V5.21521C9.33875 4.63136 9.81202 4.15808 10.3959 4.15808H12.5101C13.094 4.15808 13.5673 4.63136 13.5673 5.21521V7.32947C13.5673 7.91321 13.094 8.3866 12.5101 8.3866H10.3959C9.81202 8.3866 9.33875 7.91321 9.33875 7.32947V7.06519H6.96021V13.9365H13.5673V13.6722C13.5673 13.0884 14.0405 12.6151 14.6244 12.6151H16.7386C17.3225 12.6151 17.7958 13.0884 17.7958 13.6722Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlGroupIcon);
export default __webpack_public_path__ + "static/media/control-group-icon.bf3d5bd9559307d2a48e843d748c1c67.svg";
export { ForwardRef as ReactComponent };